// src/pages/users/UserList.js
import EditIcon from '@mui/icons-material/Edit';
import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminHeader from '../../components/AdminHeader';
import LayoutContainer from '../../components/LayoutContainer';
import functionalDepartmentService from '../../services/functionalDepartmentService';

const FunctionDepartmentList = () => {
  const [funcDepartmentList, setFuncDepartmentList] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFuncDept = async () => {
      const response =
        await functionalDepartmentService.getFunctionalDepartments();
      setFuncDepartmentList(response.data);
    };
    fetchFuncDept();
  }, []);

  return (
    <LayoutContainer>
      <AdminHeader title='Departments' />
      <div className='page-content-wrapper scrollable'>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant='contained'
            sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
            onClick={() => navigate('/functionalDepartment/new')}
          >
            Add Department
          </Button>
        </Box>
        <Table className='table'>
          <TableHead className='tableHead'>
            <TableRow>
              <TableCell>Departments</TableCell>
              <TableCell>Reporting Head</TableCell>
              <TableCell>Vendor</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className='tableBody'>
            {funcDepartmentList.map((dept, index) => (
              <TableRow
                key={dept.id}
                sx={{
                  backgroundColor: index % 2 === 0 ? '#fff' : '#eaf3ff',
                }}
              >
                <TableCell>{dept.name || '-'}</TableCell>
                <TableCell>{dept.reporting_head_name || '-'}</TableCell>
                <TableCell>{dept.vendor || '-'}</TableCell>
                <TableCell>
                  <IconButton
                    onClick={() =>
                      navigate(`/functionalDepartment/edit/${dept.id}`)
                    }
                  >
                    <EditIcon sx={{ color: '#be210b' }} />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </LayoutContainer>
  );
};

export default FunctionDepartmentList;
